import { createContext, useContext, Children, createElement, cloneElement } from 'react';
import { Modal, Button } from 'antd';

// 1. 创建上下文
const ModalContext = createContext<{
    confirm: (opts: Parameters<typeof Modal.confirm>[0]) => void;
}>({
    confirm: () => {},
});

// 2. 封装 Confirm 组件（提供者）
export default ({ children }) => {
    const [modal, contextHolder] = Modal.useModal();

    // 封装 confirm 方法
    const confirm = (options) => {
        const {
            content,
            title = null,
            icon = null,
            // 完全接管 footer
            footer = null,
            ...more
        } = options;

        const instance = modal.confirm({
            title,
            icon,
            content: cloneElement(content, {
                getInstance: () => instance,
                destroy: () => instance.destroy(),
            }),
            footer,
            ...more,
        });

        return instance;
    };

    return (
        <ModalContext.Provider value={{ confirm }}>
            {Children.map(children, (child) => {
                return child;
            })}
            {contextHolder}
        </ModalContext.Provider>
    );
};

// 3. 自定义 Hook，方便外部使用
export const useConfirm = () => useContext(ModalContext);
